import { useCallback, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { OnDocumentLoadSuccess } from 'react-pdf/dist/esm/shared/types.js';
import { cn, Stack } from '@prenuvo/halo-foundation';

import 'react-pdf/dist/esm/Page/TextLayer.css';

import { DocumentError } from '../document-error.component';
import { DocumentLoading } from '../document-loading.component';
import { OPTIONS } from './pdf-viewer.constant';
import { useWidth } from './use-width.hook';

interface PdfViewerProps {
  url: string;
}

export function PdfViewer({ url }: PdfViewerProps) {
  const [numPages, setNumPages] = useState(0);
  const [isDocumentLoadSettled, setIsDocumentLoadSettled] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const width = useWidth(ref);

  const handleDocumentLoadSuccess: OnDocumentLoadSuccess = useCallback((doc) => {
    setNumPages(doc.numPages);
    setIsDocumentLoadSettled(true);
  }, []);

  return (
    <Stack
      className={cn('mx-auto max-h-[calc(100vh-128px)] w-full overflow-auto', {
        'opacity-0': !isDocumentLoadSettled,
      })}
      justification="center"
      ref={ref}
    >
      <Document
        key={url}
        error={<DocumentError />}
        file={url}
        loading={<DocumentLoading />}
        onLoadError={() => setIsDocumentLoadSettled(true)}
        onLoadSuccess={handleDocumentLoadSuccess}
        options={OPTIONS}
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            className="w-full"
            pageNumber={index + 1}
            renderAnnotationLayer={false}
            width={width}
          />
        ))}
      </Document>
    </Stack>
  );
}
